import styled from 'utils/emotion';

export const ProductDetailsStyled = styled('div')({
  pointerEvents: 'none',
});
